var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_9986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4H8C6.93913 4 5.92172 4.42143 5.17157 5.17157C4.42143 5.92172 4 6.93913 4 8V24C4 25.0609 4.42143 26.0783 5.17157 26.8284C5.92172 27.5786 6.93913 28 8 28H24C25.0609 28 26.0783 27.5786 26.8284 26.8284C27.5786 26.0783 28 25.0609 28 24V8C28 6.93913 27.5786 5.92172 26.8284 5.17157C26.0783 4.42143 25.0609 4 24 4ZM8 6.66667H24C24.3536 6.66667 24.6928 6.80714 24.9428 7.05719C25.1929 7.30724 25.3333 7.64638 25.3333 8V19.1467L21.0667 15.5067C20.4056 14.9627 19.5761 14.6653 18.72 14.6653C17.8639 14.6653 17.0344 14.9627 16.3733 15.5067L6.66667 23.6V8C6.66667 7.64638 6.80714 7.30724 7.05719 7.05719C7.30724 6.80714 7.64638 6.66667 8 6.66667ZM24 25.3333H8.74667L18.08 17.5467C18.2593 17.4135 18.4767 17.3417 18.7 17.3417C18.9233 17.3417 19.1407 17.4135 19.32 17.5467L25.3333 22.6667V24C25.3333 24.3536 25.1929 24.6928 24.9428 24.9428C24.6928 25.1929 24.3536 25.3333 24 25.3333Z",
    fill: "#C2C4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.3334C11.7713 13.3334 12.6667 12.4379 12.6667 11.3334C12.6667 10.2288 11.7713 9.33337 10.6667 9.33337C9.56218 9.33337 8.66675 10.2288 8.66675 11.3334C8.66675 12.4379 9.56218 13.3334 10.6667 13.3334Z",
    fill: "#C2C4C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_9986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementImageUpload);
export default __webpack_public_path__ + "static/media/icon_settlement_image_upload.23a49bca9f9a094224111f0f46e40705.svg";
export { ForwardRef as ReactComponent };